import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function EquipmentPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="อุปกรณ์"
            apiPath="/equipments" 
            fieldKey="name"
            createDefaultName="รายการใหม่" 
            initialItems={[]}
        />
    );
}
